export const httpHeaders = {
  clientIdentifier: 'TR-WEB-5',
  clientIdentifierOmpWeb: 'OMP-Web'
};

const httpMethods = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  PATCH: 'patch',
  DELETE: 'delete'
};

export const httpCodes = {
  OK: 200,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  GENERIC_400: 400
};

export default httpMethods;
